import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "carregando d-flex flex-column justify-content-center align-items-center" }
const _hoisted_3 = { class: "loading p-4 bg-dark rounded" }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isLoading: { type: Boolean, required: true, default: false },
  mensagem: { type: String, required: true, defaul: "Processando..." },
  spinerTipo: { type: String, required: false, default: "spinner-border spinner-border-sm" },
  corFont: { type: String, required: false, default: "text-white" },
  corSpiner: { type: String, required: false, default: "text-white" },
},
  setup(__props) {



var props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["mb-2", __props.corSpiner])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["fw-bold fs-5", __props.corFont])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["me-2", __props.spinerTipo])
              }, null, 2),
              _createElementVNode("label", null, _toDisplayString(__props.mensagem), 1)
            ], 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})